/* eslint-disable quote-props */
export default {
    'ok': 'Ok',
    'Search': 'Pesquisar',
    'Address': 'Endereço',
    'Routing': 'Rota',
    'From here': 'Origem rota',
    'Waypoint here': 'Passando por aqui',
    'Destination here': 'Destino rota',
    'Distance': 'Distância',
    'Line': 'Linha',
    'Road': 'Estrada',
    'Area': 'Área',
    'fullScreen': 'Tela cheia',
    'gasStation': 'Gasolineira',
    'gasstations': 'Gasolineiras',
    'naturalgasstations': 'gasolineiras de gas natural',
    'electricchargers': 'Carregadores elétricos',
    'detailedLocation': 'Localização detalhada',
    'street': 'Rua',
    'city': 'Localidade',
    'postalCode': 'Código postal',
    'municipality': 'Municipalidade',
    'regionLevel2': 'Província',
    'regionLevel1': 'Região',
    'country': 'País',
    'altitude': 'Altitud',
    'maximumSpeed': 'Velocidade máxima',
    'xy': 'Y,X',
    'copy': 'Copiar',
    'go': 'Ir',
    'call': 'Chamar',
    'send:': 'Enviar',
    'calculateIsochrone': 'Calcule isócrono',
    'car': 'Automóvel',
    'bicycle': 'Bicicleta',
    'onFoot': 'A pé',
    'simplified': 'Simplificado',
    'detailed': 'Detalhado',
    'starting': 'Origem',
    'arrival': 'Destino',
    'increments': 'Incrementos',
    'maxWeight': 'Peso max.',
    'maxAxleWeight': 'Peso eixo max.',
    'maxHeight': 'Altura max.',
    'maxLength': 'Comprimento max.',
    'maxWidth': 'Largura max.',
    'maxSpeed': 'Velocidade máxima',
    'showRoadRestrictions': 'Mostrar restrições de estrada',
    'dangerousGoods': 'Mercadorias perigosas',
    'trc': 'Código de restrição do túnel',
    'trucks': 'Caminhões',
    'temporalRestrictions': 'Restrições temporárias',
    'startTime': 'Hora de início',
    'endTime': 'Hora de término',
    'morning': 'Amanhã',
    'afternoon': 'Tarde',
    'price': 'Preco',
    'schedule': 'Horárip',
    'font': 'Fonte',
    'liveTraffic': 'Tráfego atual',
    'forecastTraffic': 'Tráfego esperado',
    'slow': 'Lento',
    'fast': 'Rápido',
    'roadWorks': 'Obras',
    'AbnormalTraffic': 'Trânsito anormal',
    'queueingTraffic': 'Trânsito com filas',
    'slowTraffic': 'Trânsito lento',
    'stationaryTraffic': 'Trânsito parado',
    'Accident': 'Acidente',
    'accident': 'Acidente',
    'EnvironmentalObstruction': 'Obstrução ambiental',
    'flooding': 'Inundação',
    'landslips': 'Deslizamentos de terra',
    'rockfalls': 'Desmoronamento de rochas',
    'GeneralObstruction': 'Obstrução geral',
    'incident': 'Incidente',
    'objectOnTheRoad': 'Objeto na estrada',
    'obstructionOnTheRoad': 'Obstrução na estrada',
    'shedLoad': 'Carga perdida',
    'MaintenanceWorks': 'Trabalhos de manutenção',
    'maintenanceWork': 'Trabalhos de manutenção',
    'other': 'Outros',
    'resurfacingWork': 'Trabalhos de recapeamento',
    'MaintenanceWorks roadworks': 'Trabalhos de manutenção, obras',
    'MaintenanceWorks roadworks, maintenanceWork': 'Trabalhos de manutenção, obras, trabalhos de manutenção',
    'roadworks': 'Obras rodoviárias',
    'roadworks, maintenanceWork': 'Obras rodoviárias, trabalhos de manutenção',
    'roadworks, maintenanceWork, resurfacingWork': 'Obras rodoviárias, trabalhos de manutenção, trabalhos de recapeamento',
    'roadworks, resurfacingWork': 'Obras rodoviárias, trabalhos de recapeamento',
    'NetworkManagement': 'Gestão de rede',
    'contraflow': 'Fluxo contrário',
    'intermittentShortTermClosures': 'Fechamentos intermitentes de curta duração',
    'laneOrCarriagewayClosed': 'Faixa ou via fechada',
    'narrowLanes': 'Faixas estreitas',
    'restrictions': 'Restrições',
    'roadClosed': 'Estrada fechada',
    'singleAlternateLineTraffic': 'Trânsito alternado em faixa única',
    'VehicleObstruction': 'Obstrução por veículo',
    'brokenDownVehicle': 'Veículo avariado',
    'slowMovingMaintenanceVehicle': 'Veículo de manutenção lento',
    'snowplough': 'Removedor de neve',
    'vehicleOnFire': 'Veículo em chamas',
    'obstruction': 'Obstrução',
    'monday': 'Segunda-feira',
    'tuesday': 'Terça-feira',
    'wednesday': 'Quarta-feira',
    'thursday': 'Quinta-feira',
    'friday': 'Sexta-feira',
    'saturday': 'Sábado',
    'sunday': 'Domingo',
    'direction': 'Endereço',
    'mapCenter': 'Centro do mapa',
    'maxResults': 'Resultados max.',
    'maxRadius': 'Raio máximo',
    'viewOnMap': 'Veja no mapa',
    'proximity': 'Proximidade',
    'selectCategories': 'Selecione Categorias',
    'minimizeRoutingMenu': 'Minimizar o menu da rota',
    'closeRouteMenu': 'Fechar o menu da rota',
    'writeOrClickMap': 'Digite ou clique no mapa',
    'routeTo': 'Rumo a ...',
    'waypoint': ' Estágio ...',
    'addWaypoint': 'Adicionar waypoint',
    'cleanRoute': 'Eliminar rota',
    'saveRoute': 'Guardar rota',
    'printRoute': 'Imprimir rota',
    'modifyRouteOptions': 'Modificar opções de rota',
    'logisticsRoute': 'Rota para Caminhões',
    'routeType': 'Tipo rota',
    'time': 'Tempo',
    'restTime': 'Tempo de descanso',
    'distance': 'Distancia',
    'avoidTolls': 'Evitar pedágios',
    'realtime': 'Tempo real',
    'optimizedRoute': 'Roteamento otimizado',
    'addedCosts': 'Custos adicionados',
    'departureTime': 'Hora de saída',
    'moreDetails': 'Mais detalhes',
    'routeCar': 'Rota de carro',
    'routeTruck': 'Rota de caminhão',
    'withoutTraffic': 'sem trânsito',
    'ofRest': 'de descanso (tacógrafo)',
    'ZBEInfo': 'Informações sobre esta zona de baixas emissões',
    'hour': 'Hora',
    'roadRestrictions': 'Restrições de estrada',
    'addBreakTime': 'Adicionar tempo de pausa (tacógrafo)',
    'twoDrivers': 'Dois condutores',
    'refresh': 'Atualização',
    'disabled': 'Desativado',
    'sunLight': 'Iluminação solar',
    'neighborhoods': 'Bairros',
    'postalcodes': 'Códigos postais',
    'municipios': 'Municípios',
    'routeStopsFrom': 'Desde:',
    'routeStopsThrought': 'passando por:',
    'routeStopsTo': 'hacia:',
    'routeStopsTrafficDelay': 'atraso pelo tráfego atual',
    'routeSummaryDetails': 'ROTA DETALHADA',
    'routeSummaryTraficJam': 'atraso',
    'searchAddress': 'Endereço',
    'searchPostalCode': 'Código postal',
    'searchCoordinates': 'Coordenadas',
    'searchLocality': 'Localidade',
    'searchPOIs': 'POIs',
    'searchSearchBtn': 'Pesquisa',
    'searchNearestAddress': 'Endereço mais próximo',
    'searchSelectCountry': 'Selecione país',
    'searchAllCountries': 'Todos os países',
    'searchProjection': 'Projeção',
    'searchXCoordinate': 'Coordenada X',
    'searchYCoordinate': 'Coordenada Y',
    'searchCandidates': 'Candidatos',
    'tooltipAdvancedSearch': 'Busca avançada',
    'tooltipRouting': 'Calcular rota',
    'tooltipPois': 'Pontos de interesse',
    'tooltipMeteo': 'Previsão do tempo',
    'tooltipGasStations': 'Postos de gasolina',
    'tooltipTraffic': 'Tráfego',
    'tooltipZBE': 'Zonas de baixas emissões',
    'tooltipClean': 'Limpe o mapa',
    'tooltipDraw': 'Desenhar',
    'tooltipLayerSwitcher': 'Tipo de mapa',
    'tooltipLayerRegion': 'Adicionar camadas administrativas',
    'tooltipLogisticsRestrictions': 'Restrições de estrada para caminhões',
    'tooltipIsochrones': 'Calcule Isócronas',
    'tooltipBuildings3D': 'Veja edifícios em 3D',
    'rainRadar': 'Radar de chuva',
    'notificationRouteCantGetPosition': 'Sua localização não pode ser obtida. Digite o endereço no formulário de origem.',
    'notificationErrorSavingKML': 'Erro ao salvar o KML.',
    'notificationErrorGetPostalCode': ' O código postal não pode ser obtido. Erro: ',
    'notificationControlAlreadyExists': 'O controle já existe:',
    'notificationSelectCategories': 'Selecione as categorias de pontos de interesse primeiro.',
    'notificationPoisNotFound': 'POIs não encontrados.',
    'notificationDrawIsochrone': 'Clique no ponto no mapa onde você deseja calcular a isócrona',
    'notificationErrorGetPathRouting': 'Não foi possível encontrar o caminho da rota, verifique os pontos de cruzamento',
    'assertMapNotDefined': 'Map not defined',
    'assertFeatureExists': 'Feature already exists',
    'assertUnknownBaseLayer': 'Unknown setBaseLayer: ',
    'assertLayerNotSpecified': 'Layer not specified',
    'asserInvalidObjectLonLat': 'Not a \'cercalia.LonLat\' type object',
    'assertUknownWeight': 'Uknown weight: ',
    'assertParameterIsNotFunction': 'Parameter is not a callback function',
    'assertUknownParameter': 'Uknown parameter: ',
    'assertOriginInvalid': 'Can\'t calculate route. Invalid origin: ',
    'assertStepInvalid': 'Can\'t calculate route. Invalid step: ',
    'assertDestinationInvalid': 'Can\'t calculate route. Invalid destination: ',
    'assertProjectionNotDefined': 'Layer projection not declared: ',
    'assertGpsNotPosition': 'Can\'t get GPS position.',
};
//# sourceMappingURL=pt.js.map